<template>
    <div
        class="VFilter"
        @mouseover="catchVFilterEvent"
    >
        <div
            class="VFilter-title"
            @click="changeDropdownVisibility"
        >
            <VButton :is-active="isShowDropdown">
                <span
                    v-if="!isShowDropdown"
                    class="text"
                >
                    {{ this.options[this.currentSourceIndex].title }}
                      <span class="text_capitalize">{{ currentSource.name }}</span>
                    <span class="text_thin">
                     | Attributes:
                    </span>
                {{ this.options[this.currentSourceIndex].features.filter((item) => item.isActive).length + '/' +
                this.options[this.currentSourceIndex].features.length }}
                </span>
                <span
                    v-else
                    class="text"
                >
                    Choose source
                </span>
            </VButton>
        </div>
        <div
            class="VFilter-dropdown"
            v-if="isShowDropdown"
            v-click-outside="hideDropdown"
        >
            <div class="VFilter-dropdown-menu">
                <div
                    class="VFilter-dropdown-menu__item"
                    :class="{'VFilter-dropdown-menu__item_active': appIndex === currentSourceIndex}"
                    v-for="(app, appIndex) in options"
                    :key="appIndex"
                    @click="changeApp(appIndex, app)"
                    @mouseover="showTooltip($event,'appTooltip',app)"
                >
                    <span class="app-name">{{ app.name }}</span>
                </div>
            </div>
            <div class="VFilter-dropdown__content content">
                <div class="content__top">
                    <div class="content__top__title">
                        Attributes
                    </div>
                    <div class="select-all">
                        <div class="select-all__label">
                            Select All
                        </div>
                        <div @click="selectAllCurrentSourceFeatures">
                            <VCheckbox
                                :checked="isCurrentSourceFeaturesAllActive"
                            />
                        </div>
                    </div>
                </div>
                <div class="checkbox">
                    <div
                        v-for="(feature, attrIndex) in allFeatures"
                        :key="attrIndex"
                        class="checkbox__row"
                        @click="selectFeature(feature.name)"
                        :class="{disabled:!currentSourceFeaturesNames.includes(feature.name.trim())}"
                    >
                        <VCheckbox
                            :disabled="!currentSourceFeaturesNames.includes(feature.name.trim())"
                            :checked="localDisplayedActiveFeaturesNames.includes(feature.name.trim())"
                        />
                        <div
                            class="checkbox__label"
                        >
                            {{ feature.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getSourceGroups} from '../api/apiServices';
    
    export default {
        name: 'VFilterAttributes',
        model: {
            prop: 'items',
            event: 'updateItems',
        },
        props: {
            options: {
                type: Array,
                required: true,
                default: () => [],
            },
            groups: {
                type: Array,
                required: false,
                default: () => [],
            },
            items: {
                type: Array,
                required: true,
                default: () => [],
            },
            isCatchEvent: {
                type: Boolean,
                default: false,
            },
            sync: {
                type: Boolean,
                default: false,
            },
            allFeatures: {
                type: Array,
                isRequired: true,
            },
            displayedActiveFeaturesNames: {
                type: Array,
                isRequired: true,
            },
            currentSourceName: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                isShowDropdown: false,
                currentSourceIndex: null,
                localDisplayedActiveFeaturesNames: [],
            };
        },
        watch: {
            currentSourceName: {
                immediate: true,
                handler(sourceName) {
                    this.currentSourceIndex = getSourceGroups().findIndex((group) => group.name === sourceName);
                },
            },
            displayedActiveFeaturesNames: {
                immediate: true,
                handler(displayNames) {
                    this.localDisplayedActiveFeaturesNames = _.cloneDeep(displayNames);
                },
            },
        },
        computed: {
            currentSource() {
                return this.options[this.currentSourceIndex];
            },
            currentSourceFeaturesNames() {
                return this.currentSource.features.map(({name}) => name);
            },
            isCurrentSourceFeaturesAllActive() {
                const currentSourceFeaturesActive = [];
                this.localDisplayedActiveFeaturesNames.forEach((featureName) => {
                    const currentSourceActiveFeatureName = this.currentSourceFeaturesNames.find((feature) => feature === featureName);
                    if (currentSourceActiveFeatureName) {
                        currentSourceFeaturesActive.push(currentSourceActiveFeatureName);
                    }
                });
                return currentSourceFeaturesActive.length === this.currentSourceFeaturesNames.length;
            },
        },
        methods: {
            clearFeatureAfterDelete(feature){
                if (!feature.isActive) {
                    const nameIndex = this.localDisplayedActiveFeaturesNames.findIndex((featureName) =>
                        featureName === feature.name);
                    this.localDisplayedActiveFeaturesNames.splice(nameIndex, 1);
                    this.displayedActiveFeaturesNames.splice(nameIndex, 1);
                }
            },
            selectAllCurrentSourceFeatures() {
                if (!this.isCurrentSourceFeaturesAllActive) {
                    this.localDisplayedActiveFeaturesNames = _.cloneDeep(this.currentSourceFeaturesNames);
                } else {
                    this.localDisplayedActiveFeaturesNames = [];
                }
            },
            selectFeature(featureName) {
                const isDisabled = !this.currentSourceFeaturesNames.includes(featureName.trim());
                const isActive = this.localDisplayedActiveFeaturesNames.includes(featureName);
                if (isActive) {
                    this.localDisplayedActiveFeaturesNames = this.localDisplayedActiveFeaturesNames.filter((name) =>
                        name !== featureName);
                } else if (!isActive && !isDisabled) {
                    this.localDisplayedActiveFeaturesNames.push(featureName);
                }
            },
            changeDropdownVisibility() {
                if (this.isShowDropdown) {
                    this.hideDropdown();
                } else {
                    this.isShowDropdown = true;
                }
            },
            showTooltip(event, tooltipFunctionName, data) {
                this.$emit('showTooltip', event, tooltipFunctionName, data);
            },
            hideDropdown() {
                this.isShowDropdown = false;
                if (!this.sync) {
                    this.updateFeatures();
                }
            },
            updateFeatures() {
                const newCurrentSource = _.cloneDeep(this.currentSource);
                newCurrentSource.features.forEach((feature) => {
                    feature.isActive = this.localDisplayedActiveFeaturesNames.includes(feature.name);
                });
                newCurrentSource.displayedActiveFeaturesNames = this.localDisplayedActiveFeaturesNames;
                this.$emit('updateFeatures', newCurrentSource);
            },
            catchVFilterEvent(event) {
                if (this.isCatchEvent && event.target.classList.contains('VFilter-dropdown-row')) {
                    const self = this;
                    const addMouseOutListener = function (el) {
                        const listener = () => {
                            self.$emit('catchEvent', event, false);
                            el.removeEventListener('mouseleave', listener, false);
                        };
                        el.addEventListener('mouseleave', listener, false);
                    };
                    
                    this.$emit('catchEvent', event, true);
                    addMouseOutListener(event.target);
                }
            },
            changeApp(index) {
                if (index !== this.currentSourceIndex) {
                    this.currentSourceIndex = index;
                    this.$emit('updateTempCurrentSourceEventsNames', this.options[this.currentSourceIndex]);
                }
            },
        },
    };

</script>

<style
    scoped
    lang="scss"
>
    .VFilter {
        position: relative;
        
        
        &-title {
            width: 447px;
            
            .text {
                font-weight: 700;
                
                &_thin {
                    font-weight: normal;
                }
                
                &_capitalize {
                    text-transform: capitalize;
                }
            }
        }
        
        &-dropdown {
            position: absolute;
            display: flex;
            z-index: $dropdown-z-index;
            background: #FFFFFF;
            min-width: 154px;
            overflow: auto;
            border-radius: 5px;
            border-top: 10px solid #FFFFFF;
            @include scrollbar-styles;
            @include default-shadow;
            
            &-group {
                padding: 20px;
                font-weight: bold;
            }
            
            &-menu {
                font-size: 14px;
                line-height: 18px;
                width: fit-content;
                border-right: 2px solid $light-blue-color;
                
                &__item {
                    text-align: left;
                    cursor: pointer;
                    padding: 5px 17px;
                    white-space: nowrap;
                    
                    &:last-child {
                        margin-bottom: 10px;
                    }
                    
                    &_active {
                        background: $light-blue-color;
                    }
                    
                    .app-name {
                        text-transform: capitalize;
                        font-weight: 400;
                    }
                }
            }
            
            .content {
                width: 625px;
                padding-left: 30px;
                padding-bottom: 10px;
                
                &__top {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 17px;
                    padding-right: 30px;
                    
                    &__title {
                        text-align: left;
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 700;
                        width: fit-content;
                        //padding-bottom: 17px;
                    }
                    
                    .select-all {
                        display: flex;
                        align-items: center;
                        
                        &__label {
                            margin-right: 10px;
                        }
                    }
                }
                
                .checkbox {
                    display: flex;
                    flex-wrap: wrap;
                    
                    &__row {
                        flex: 1;
                        min-width: 23%;
                        max-width: 25%;
                        margin-bottom: 10px;
                        display: flex;
                        cursor: pointer;
                        align-items: center;
                    }
                    
                    &__label {
                        margin-left: 10px;
                    }
                }
            }
        }
    }

</style>
